import { setLoading, setGlobalMessage } from '../../../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, GLOBAL_VALUES } from 'eebac/constants';
import { Catch } from '../../../api_exception';

const BASE_PATH = "COMPANY_WORK_POST_REPLIES";

export const loadPostReplies = (postId, rowsPerPage = null, page = null) =>
    (dispatch, getState, client) => {

        let state = getState().COMPANY_WORK_POST_REPLIES;

        let apiData = {
            itemsCount: state.rowsPerPage,
            currentPage: state.page + 1
        }

        if (rowsPerPage) {
            apiData.itemsCount = rowsPerPage;
        }

        if (page !== null) {
            apiData.currentPage = page + 1;
        }

        dispatch(setLoading(true));
        dispatch(isLoadingReplies(true));

        client.post(`/company/work_post/${postId}/replies`, apiData).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.replies) {
                    dispatch(setPostRepliesData(result.data.replies,
                        (result.currentPage - 1), result.itemsCount, result.totalCount));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
                dispatch(isLoadingReplies(false));
            }).catch(error => {
                dispatch(isLoadingReplies(false));
                Catch(error, dispatch);
            });
    }


export const loadContractorProfile = (id, viewContact = false) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        let apiPath = `/company/contractor_profile/${id}`;
        if (viewContact) {
            apiPath = `/company/contractor_profile_contact/${id}`;
        }

        client.get(apiPath).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.contractor) {
                    dispatch(setProfileData(result.data.contractor));
                    dispatch(viewVendorProfile(true));
                } else {
                    dispatch(setProfileData(null));
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                    dispatch(viewVendorProfile(false));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
                dispatch(setProfileData(null));
            });
    }
export const SET_POSTS_REPLIES_DATA = `${BASE_PATH}/SET_POSTS_REPLIES_DATA`;
export const CLEAR_POSTS_REPLIES_DATA = `${BASE_PATH}/CLEAR_POSTS_REPLIES_DATA`;
export const OPEN_SCHEDULE = `${BASE_PATH}/OPEN_SCHEDULE`;
export const VIEW_PROFILE = `${BASE_PATH}/VIEW_PROFILE`;
export const SET_VENDOR_PROFILE = `${BASE_PATH}/SET_VENDOR_PROFILE`;
export const SET_LOADING_REPLIES = `${BASE_PATH}/SET_LOADING_REPLIES`;

export const setPostRepliesData = (replies, page, rowsPerPage, totalRows) => ({
    type: SET_POSTS_REPLIES_DATA,
    replies,
    page,
    rowsPerPage,
    totalRows
});

export const clearPostRepliesData = () => ({
    type: CLEAR_POSTS_REPLIES_DATA
});

export const openScheduleMeeting = (open, vendorId, vendorName) => ({
    type: OPEN_SCHEDULE,
    open,
    vendorId,
    vendorName
});

export const viewVendorProfile = (view) => ({
    type: VIEW_PROFILE,
    view
});

export const setProfileData = (data) => ({
    type: SET_VENDOR_PROFILE,
    data
});

export const isLoadingReplies = (isLoadingReplies) => ({
    type: SET_LOADING_REPLIES,
    isLoadingReplies
});

const initialState = {
    replies: [],
    page: 0,
    rowsPerPage: GLOBAL_VALUES.DEFAULT_ROWS_PER_PAGE,
    totalRows: 0,
    openSchedule: false,
    vendorId: '',
    vendorName: '',
    viewProfile: false,
    isLoadingReplies: false
}

export default function reducer(state = { ...initialState }, action) {
    let newState = null;
    switch (action.type) {
        case SET_POSTS_REPLIES_DATA:
            newState = {
                ...state,
                replies: [...action.replies],
                page: action.page,
                rowsPerPage: action.rowsPerPage,
                totalRows: action.totalRows
            };
            return newState;

        case CLEAR_POSTS_REPLIES_DATA:
            return { ...initialState }
        case OPEN_SCHEDULE:
            return {
                ...state,
                openSchedule: action.open,
                vendorId: action.vendorId,
                vendorName: action.vendorName
            };
        case VIEW_PROFILE:
            return {
                ...state,
                viewProfile: action.view
            };
        case SET_VENDOR_PROFILE:
            return {
                ...state,
                profileData: action.data
            }
        case SET_LOADING_REPLIES:
            return {
                ...state,
                isLoadingReplies: action.isLoadingReplies
            }

    }

    return state;
}